import mfeAppsMap from "./mfe.json";

export default function getMfeStatus(mfeName) {
  return Object.keys(mfeAppsMap.mfes)
    .filter(mfe => mfe === mfeName)
    .reduce((obj, key) => {
      return { "isActive": mfeAppsMap.mfes[key].active ? mfeAppsMap.mfes[key].active : false };
    }, {});
}
